import React from 'react';
import { Box, Typography } from '@mui/material';
import Image from 'next/image';
import { isNerdyTipAndProgressBarActive } from 'src/lib/experiments';
import { useAppSelector } from 'src/redux/hooks';
import { getExperiments } from 'src/redux/selectors';

export const NERDY_INSIGHT_LABEL = 'Nerdy Insight';

export const NerdyTip = ({ text }: { text: string }) => {
  const experiments = useAppSelector(getExperiments);
  if (!text || !isNerdyTipAndProgressBarActive(experiments)) return null;
  return (
    <Box
      position="relative"
      paddingLeft="1rem"
      paddingTop={3}
      paddingBottom={2}
      minWidth="300px"
      sx={(theme) => ({
        [theme.breakpoints.up('sm')]: { marginTop: 3 },
      })}
    >
      <Box
        position="absolute"
        marginLeft={1}
        height="90%"
        top="5px"
        left={0}
        borderLeft="solid 2px"
        borderColor="blue.light"
      />
      <Box
        position="absolute"
        marginTop={1}
        width="70%"
        top={0}
        left="5px"
        borderTop="solid 2px"
        borderColor="blue.light"
      />

      <Typography
        variant="accent"
        color="text.secondary"
        position="absolute"
        top="-2px"
        left="16px"
        bgcolor="common.white"
        paddingLeft="5px"
      >
        <Box display="flex" flexDirection="row" maxHeight="14px">
          {NERDY_INSIGHT_LABEL}
          <Box sx={{ transform: 'translate(-2px,-4px)' }}>
            <Image
              width={21}
              height={21}
              alt="nerdy tip"
              src="https://www.nerdwallet.com/cdn/cardfinder/nerdy-tip-icon.svg"
              unoptimized
            />
          </Box>
        </Box>
      </Typography>
      <Typography variant="textSmall" color="text.secondary">
        {text}
      </Typography>
    </Box>
  );
};
